"use strict";

var AppDispatcher = require('../dispatcher/AppDispatcher');
var NewsConstants = require('../constants/NewsConstants');
var getAdAPIUtils = require('../utils/getAdAPIUtils');

var getAd = {};

getAd.getAdlist = function(data) {
    AppDispatcher.dispatchAsync( getAdAPIUtils.getList(data), {
        request:NewsConstants.LOAD_AD_LIST,
        success:NewsConstants.LOAD_AD_SUCCESS,
        failure:NewsConstants.LOAD_AD_FAILURE
    }, {data: data});
};

getAd.getGodIzvlist = function(data) {
    AppDispatcher.dispatchAsync( getAdAPIUtils.getList(data), {
        request:NewsConstants.LOAD_GOD_IZV_LIST,
        success:NewsConstants.LOAD_GOD_IZV_SUCCESS,
        failure:NewsConstants.LOAD_GOD_IZV_FAILURE
    }, {data: data});
};


module.exports = getAd;



/** WEBPACK FOOTER **
 ** ./modules/actions/getAdAction.js
 **/